import { FC, useState, createContext, Dispatch, ReactNode, useEffect, useRef, useCallback } from "react";
import { getPocToken } from "src/api/getPocToken";
import { getNonLoggedAuthId } from "src/api/getNonLoggedAuthId";
// import mflImage from "../assets/mflImage.png";
// import sleeperImage from "../assets/sleeperImage.png";
// import fleaflickerImage from "../assets/fleaflicker.png";
// import yahooImage from "../assets/yahoo.png";
import mflImage from "../assets/platformsLogos/mfl-logo.svg";
import sleeperImage from "../assets/platformsLogos/sleeper-logo.svg";
import fleaflickerImage from "../assets/platformsLogos/fleaflicker-logo.svg";
import yahooImage from "../assets/platformsLogos/yahoo-logo.svg";
import espnImage from "../assets/platformsLogos/espn-logo.svg";
import fantraxImage from "../assets/platformsLogos/fantrax-logo.svg";
import ffpcImage from "../assets/platformsLogos/ffpc-logo.svg";
import { useAuth0 } from "@auth0/auth0-react";
import { LeaguePlatform, SectionData, TeamsData, UserDataPlatform, SelectedTeams, UserPreferencesData } from "src/mockup/UserPreferencesData";
import { getUserPreferences } from "src/api/getUserPrefrences";
import { postUserPreferences } from "src/api/postUserPreferences";
import { claimNonLoggedPreferences } from "src/api/claimNonLoggedPreferences";
import { isEqual } from "lodash";
import { validateTeamData } from "src/utils/teamValidation";
import { getValidYahooTokenfromBack } from "src/api/getValidYahooToken";
import { TeamsHomePageRef } from "../components/PlatformSelector/TeamsDropdown";
import { getUserLeagues } from "src/api/getUserLeagues";
import { getAllowedPlatforms } from "src/api/getAllowedPlatforms";
import { getAllowedButtonsSections, AllowedButtonsSections } from "src/api/getAllowedButtonsSections";
import { getSeasonPassPrice } from "src/api/getSeasonPassPrice";
import { loadFrontRuntimeConfig } from "src/services/runtimeFrontConfig";
import { buildClientContext } from "src/utils/clientContext";
import { postClientContext } from "src/api/postClientContext";
import {
  UNSYNCED_PLATFORM_ID,
  UNSYNCED_PLATFORM_NAME,
  UNSYNCED_DEFAULT_LEAGUE_ID,
  getDefaultUnsyncedTeamsData,
  getUnsyncedUserData,
  isUnsyncedPlatform,
  migrateLegacyUnsyncedDefaultLeagueId,
} from "src/constants/unsyncedLeague";

interface WidgetProviderProps {
  children: ReactNode;
}

interface ProgressData {
  progress: number;
  timestamp: number;
}

type WidgetContext = {
  widgetToggle: boolean;
  toggleWidget: () => void;
  closeWidget: () => void;
  selectedClientId: string;
  handleUserSelection: (userId: string) => void;
  selectedPartner: string;
  setSelectedPartner: (partnerName: string) => void;
  handlePartnerSelect: (partnerName: string) => void;
  isDrawerOpen: boolean;
  openDrawer: () => void;
  closeDrawer: () => void;
  setIsDrawerOpen: Dispatch<boolean>;
  partners: string[];
  pocToken: string;
  userIdToken: string | undefined;
  clientIdToken: string | undefined;
  credits: number;
  setCredits: (credits: number) => void;
  freeCredits: number;
  setFreeCredits: (freeCredits: number) => void;
  leaguePlatforms: LeaguePlatform[];
  setLeaguePlatforms: (platforms: LeaguePlatform[]) => void;
  resetAppState: () => void;
  isTokenLoading: boolean;
  // accessAuthToken: string | null;
  message: any;
  setMessage: (message: any) => void;
  teamsDataCache: Record<string, any>;

  setTeamsDataCache: (data: Record<string, any>) => void;
  // fetchTeamsData: (platformId: string, userDataPlatform: any) => Promise<any>;
  userDataCache: Record<string, any>;
  setUserDataCache: (data: Record<string, any>) => void;
  isLoadingPreferences: boolean;
  updatePlatformData: (data: PlatformData) => void;
  selectedTeamInfo: SelectedTeamInfo | null;
  setSelectedTeamInfo: (teamInfo: SelectedTeamInfo | null) => void;
  handleTeamSelection: (teamName: string, leagueId: string) => Promise<void>;
  sectionData: SectionData;
  setSectionData: (data: SectionData) => void;
  updateSectionData: (section: keyof SectionData, data: any) => void;
  selectedTeams: SelectedTeams;
  setSelectedTeams: (teams: SelectedTeams) => void;
  setYahooToken: (token: string | null) => void;
  yahooToken: string | null;
  setYahooLeagueId: (newLeagueId: string | null) => void;
  yahooLeagueId: string | null;
  isYahooLoading: boolean;
  setIsYahooLoading: (loading: boolean) => void;
  leagueIdPlatform: string | null;
  setLeagueIdPlatform: (leagueId: string | null) => void;
  dataLoadedFromTeamsPage: boolean;
  setDataLoadedFromTeamsPage: (loaded: boolean) => void;
  cancelPendingRequests: () => void;
  setCurrentAbortController: (controller: AbortController | null) => void;
  getValidYahooToken: () => Promise<string | null>;
  commonLeagueLeagueType: string;
  setCommonLeagueLeagueType: (leagueType: string) => void;
  updateYahooToken: (newToken: string | null) => void;
  isTransitioning: boolean;
  setIsTransitioning: (transitioning: boolean) => void;
  // activeStreamRequests: React.RefObject<Set<string>>;
  buttonProgress: Record<string, ProgressData>;
  updateButtonProgress: (key: string, progress: number) => void;
  getButtonProgress: (key: string) => number;
  allowedPlatforms: string[] | null;
  setAllowedPlatforms: (platforms: string[] | null) => void;
  allowedButtonsSections: AllowedButtonsSections | null;
  setAllowedButtonsSections: (config: AllowedButtonsSections | null) => void;
  lastUpdatedTimestamps: Record<string, string>;
  setLastUpdatedTimestamps: Dispatch<React.SetStateAction<Record<string, string>>>;
  calculatorSettingsMap: Record<string, any>;
  setCalculatorSettingsMap: Dispatch<React.SetStateAction<Record<string, any>>>;
  keeperDrawerSeenMap: Record<string, boolean>;
  setKeeperDrawerSeenMap: Dispatch<React.SetStateAction<Record<string, boolean>>>;
  aiSettings: Record<string, boolean>;
  setAiSettings: Dispatch<React.SetStateAction<Record<string, boolean>>>;
  footerSignUpDismissedAt: string | null;
  setFooterSignUpDismissedAt: Dispatch<React.SetStateAction<string | null>>;
  forceSavePreferences: (overrides?: Partial<Pick<UserPreferencesData, "aiSettings" | "keeperDrawerSeenMap" | "footerSignUpDismissedAt">>) => Promise<void>;
  seasonPassPrice: string;
  setSeasonPassPrice: (price: string) => void;
  isLoggedInAuth0ExperienceGlobal: boolean;
  setIsLoggedInAuth0ExperienceGlobal: (value: boolean) => void;
  NON_LOGGED_IN_CONFIG: any;
  nextFreeCreditsResetTime: string | null;
  setNextFreeCreditsResetTime: (time: string | null) => void;
  isIdpLeagueBlocked: boolean;
  setIsIdpLeagueBlocked: (blocked: boolean) => void;
};

interface PlatformData {
  platformId: string;
  teamsData: TeamsData[keyof TeamsData];
  userData: UserDataPlatform[keyof UserDataPlatform];
}

interface SelectedTeamInfo {
  platformId: string;
  teamName: string;
  leagueId: string;
}

export const WidgetContext = createContext<WidgetContext>({} as WidgetContext);

export const WidgetProvider: FC<WidgetProviderProps> = ({ children }) => {
  // Ref to store the teamsHomePageRef
  const teamsHomePageRef = useRef<TeamsHomePageRef>(null);
  const [widgetToggle, setWidgetToggle] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  // State for get token from authToken function, and then use it in sitAndStart and posPlayersSelected function
  const [pocToken, setPocToken] = useState(null);
  const [isTokenLoading, setIsTokenLoading] = useState(true);
  // const [userIdToken, setUserIdToken] = useState<string | null>(null);
  const [clientIdToken, setClientIdToken] = useState<string | null>(null);
  //State for accessAuthToken from getAccessTokenSilently function
  // const [accessAuthToken, setAccessAuthToken] = useState<string | null>(null);
  const [error, setError] = useState("");
  // State to manage if the cache is transitioning or not
  const [isTransitioning, setIsTransitioning] = useState(false);
  // Add a new state for the allowed platforms
  // const [allowedPlatforms, setAllowedPlatforms] = useState<string[] | null>(["MFL", "Sleeper", "Flea_flicker", "Yahoo", "ESPN"]);
  const [allowedPlatforms, setAllowedPlatforms] = useState<string[] | null>(null);

  const [allowedButtonsSections, setAllowedButtonsSections] = useState<AllowedButtonsSections | null>(null);

  //state to store and update the credits
  const [credits, setCredits] = useState(null);
  //state to store and update the free credits for free models
  const [freeCredits, setFreeCredits] = useState(5);
  //state to store next reset time for free credits
  const [nextFreeCreditsResetTime, setNextFreeCreditsResetTime] = useState<string | null>(null);

  //this state is used to store the league platforms
  const [leaguePlatforms, setLeaguePlatforms] = useState<LeaguePlatform[]>([
    // Un-Synced: always first, always "logged in" (virtual platform, no credentials)
    {
      id: UNSYNCED_PLATFORM_ID,
      user: null,
      password: null,
      isLoggedIn: true,
      isSelected: true,
      name: UNSYNCED_PLATFORM_NAME,
      credentials_type: "none",
      img: "",
    },
    {
      id: "MFL",
      user: null,
      password: null,
      isLoggedIn: false,
      isSelected: false,
      name: "MFL",
      credentials_type: "username_and_password",
      img: mflImage,
    },
    {
      id: "Sleeper",
      user: null,
      password: null,
      isLoggedIn: false,
      isSelected: false,
      name: "Sleeper",
      credentials_type: "username",
      img: sleeperImage,
    },
    {
      id: "Flea_flicker",
      user: null,
      password: null,
      isLoggedIn: false,
      isSelected: false,
      name: "FleaFlicker",
      credentials_type: "username",
      img: fleaflickerImage,
    },
    {
      id: "Yahoo",
      user: null,
      password: null,
      isLoggedIn: false,
      isSelected: false,
      name: "Yahoo",
      credentials_type: "yahoo_auth",
      img: yahooImage,
      yahooAuthUrl: null,
    },
    {
      id: "ESPN",
      user: null,
      password: null,
      isLoggedIn: false,
      isSelected: false,
      name: "ESPN",
      credentials_type: "espn_auth",
      img: espnImage,
    },
    {
      id: "Fantrax",
      user: null,
      password: null,
      isLoggedIn: false,
      isSelected: false,
      name: "Fantrax",
      credentials_type: "username",
      img: fantraxImage,
    },
    {
      id: "FFPC",
      user: null,
      password: null,
      isLoggedIn: false,
      isSelected: false,
      name: "FFPC",
      credentials_type: "username",
      img: ffpcImage,
    },
  ]);

  const toggleWidget = () => {
    setWidgetToggle(!widgetToggle);
  };
  const closeWidget = () => {
    setWidgetToggle(false);
  };

  // State to manage button progress loader
  const [buttonProgress, setButtonProgress] = useState<Record<string, ProgressData>>({});

  const [selectedClientId, setselectedClientId] = useState<string>("DTC");
  // create state to manage team name in trade
  const [selectedPartner, setSelectedPartner] = useState<string | null>(null);
  //State to manage message in chat
  const [message, setMessage] = useState<any>("Welcome to RotoGPT. Let's get started."); //State to manage teams data in cache
  // Seed Un-Synced so the virtual platform has a persistent local league from first render
  const [teamsDataCache, setTeamsDataCache] = useState<Record<string, any>>(() => ({
    [UNSYNCED_PLATFORM_ID]: getDefaultUnsyncedTeamsData(),
  }));
  //State to manage user data in cache
  const [userDataCache, setUserDataCache] = useState<Record<string, any>>(() => ({
    [UNSYNCED_PLATFORM_ID]: getUnsyncedUserData(),
  }));

  const [isLoadingPreferences, setIsLoadingPreferences] = useState(true);

  const [yahooToken, setYahooToken] = useState<string | null>(() => localStorage.getItem("yahoo_token"));

  // Add new state for selected team info
  const [selectedTeamInfo, setSelectedTeamInfo] = useState<SelectedTeamInfo | null>(null);
  const [isIdpLeagueBlocked, setIsIdpLeagueBlocked] = useState(false);
  // states for last updated timestamps for last refresh data of each team
  const [lastUpdatedTimestamps, setLastUpdatedTimestamps] = useState<Record<string, string>>({});
  // Add new state for calculator settings map
  const [calculatorSettingsMap, setCalculatorSettingsMap] = useState<Record<string, any>>({});
  const [keeperDrawerSeenMap, setKeeperDrawerSeenMap] = useState<Record<string, boolean>>({});
  // ISO-8601 UTC last time the user closed FooterSignUp (null = never dismissed)
  const [footerSignUpDismissedAt, setFooterSignUpDismissedAt] = useState<string | null>(null);
  // AI settings (e.g. audio on/off) - persisted in preferences, default matches previous local-only behavior
  const [aiSettings, setAiSettings] = useState<Record<string, boolean>>({
    audio: true,
    quan: true,
    mute: false,
    autoProcessAI: false,
  });

  // State for season pass price from MongoDB
  const [seasonPassPrice, setSeasonPassPrice] = useState<string>("1"); // Default to "1" (Pre-Season)

  // State for isLoggedInAuth0ExperienceGlobal (true = logged with Auth0, false = non-logged/free experience)
  // Initialize based on current route - if we're on /home, assume Auth0 experience
  const [isLoggedInAuth0ExperienceGlobal, setIsLoggedInAuth0ExperienceGlobal] = useState<boolean>(() => {
    // Check if we're on /home route (Auth0 experience)
    return window.location.pathname === '/home' || window.location.pathname.startsWith('/home/');
  });

  // State for non-logged config (will be updated with IP-based authId)
  const [NON_LOGGED_IN_CONFIG, setNON_LOGGED_IN_CONFIG] = useState({
    // Mock Auth0 user ID for non-logged experience (will be replaced with IP-based authId)
    NON_LOGGED_IN_AUTH_ID: "non-logged-in-auth-id-rotogpt-2025",

    // Mock access token for non-logged experience
    NON_LOGGED_IN_ACCESS_TOKEN: "non-logged-in-auth-token-rotogpt-2025",

    // Mock user object (mimics Auth0 user structure)
    NON_LOGGED_IN_USER: {
      sub: "non-logged-in-auth-id-rotogpt-2025",
      email: "RotoGPT non-logged-in-email@rotogpt.com",
      name: "RotoGPT non-logged-in-user",
      email_verified: true,
    },
  });
  // State to manage section data
  const [sectionData, setSectionData] = useState<SectionData>({
    commonLeagueData: null,
    // waiverSuggestions: null,
    waiver: null,
    news: null,
    start: null,
    rosters: null,
    rankings: null,
    allRankings: null,
    rundown: null,
    DraftAdvice: null,
    superFunction: null,
  });

  // Add new state for selectedTeams (Un-Synced is set only after user clicks a league, same as other platforms)
  const [selectedTeams, setSelectedTeams] = useState<SelectedTeams>({});

  const [yahooLeagueId, setYahooLeagueId] = useState<string | null>(() => localStorage.getItem("yahoo_league_id"));

  const [isYahooLoading, setIsYahooLoading] = useState(false);

  const [leagueIdPlatform, setLeagueIdPlatform] = useState<string | null>(null);

  const [preferencesLoaded, setPreferencesLoaded] = useState(false);

  // Tracks Auth0-/home session so we can reload prefs once after non-logged → login transition
  const wasAuth0LoggedExperienceRef = useRef(false);

  const [isPriorityOperation, setIsPriorityOperation] = useState(false);

  const [dataLoadedFromTeamsPage, setDataLoadedFromTeamsPage] = useState(false);

  const [currentAbortController, setCurrentAbortController] = useState<AbortController | null>(null);

  const [commonLeagueLeagueType, setCommonLeagueLeagueType] = useState("dynasty");

  const handleUserSelection = (userId: string) => {
    setselectedClientId(userId);
  };
  // creation of function to make the trade team name dynamic
  const handlePartnerSelect = (partnerName: string) => {
    setSelectedPartner(partnerName);
  };

  const openDrawer = () => {
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  const partners = ["THE STAY FROSTIES", "PINEAPPLE BOTTOM JEANS", "DANNY THOMAS FANCLUB"];

  const { user, getAccessTokenSilently, isAuthenticated: auth0IsAuthenticated } = useAuth0();

  // Function to fetch IP-based authId
  const fetchNonLoggedAuthId = async () => {
    // CRITICAL: Only fetch if we're in non-logged experience AND not authenticated with Auth0
    // This prevents race condition where auth0IsAuthenticated is true but isLoggedInAuth0ExperienceGlobal hasn't updated yet
    if (!isLoggedInAuth0ExperienceGlobal && !auth0IsAuthenticated) {
      try {
        const { authId } = await getNonLoggedAuthId();
        // //console.log(`[NON-LOGGED MODE] Fetched IP-based authId from backend: ${authId}`);

        // Update config with IP-based authId
        setNON_LOGGED_IN_CONFIG({
          NON_LOGGED_IN_AUTH_ID: authId,
          NON_LOGGED_IN_ACCESS_TOKEN: "non-logged-in-auth-token-rotogpt-2025",
          NON_LOGGED_IN_USER: {
            sub: authId,
            email: "RotoGPT non-logged-in-email@rotogpt.com",
            name: "RotoGPT non-logged-in-user",
            email_verified: true,
          },
        });
        // //console.log(`[NON-LOGGED MODE] Updated NON_LOGGED_IN_CONFIG with authId: ${authId}`);
      } catch (error) {
        // console.error("[NON-LOGGED MODE] Failed to fetch IP-based authId, using fallback:", error);
        // Keep default config if fetch fails
      }
    }
  };
  // Fetch IP-based authId when in non-logged experience
  useEffect(() => {
    fetchNonLoggedAuthId();
  }, [isLoggedInAuth0ExperienceGlobal, auth0IsAuthenticated]);

  // Refetch Mongo-backed front tunables when returning from background. Initial load runs in index.tsx before createRoot.
  // Web: visibilitychange. Native (Capacitor): appStateChange (visibility alone is unreliable on iOS/Android).
  useEffect(() => {
    const onVisibility = () => {
      if (document.visibilityState === "visible") {
        void loadFrontRuntimeConfig();
      }
    };
    document.addEventListener("visibilitychange", onVisibility);

    let appListener: { remove: () => Promise<void> } | undefined;
    let cancelled = false;

    void (async () => {
      try {
        const { Capacitor } = await import("@capacitor/core");
        if (cancelled || !Capacitor.isNativePlatform()) return;
        const { App } = await import("@capacitor/app");
        appListener = await App.addListener("appStateChange", ({ isActive }) => {
          if (isActive) void loadFrontRuntimeConfig();
        });
      } catch {
        // Web build or Capacitor not available
      }
    })();

    return () => {
      cancelled = true;
      document.removeEventListener("visibilitychange", onVisibility);
      void appListener?.remove();
    };
  }, []);

  // Determine if we should use Auth0 data or mock data
  // CRITICAL: If user is authenticated with Auth0, ALWAYS use real data (prevents race condition)
  // This ensures that if you're logged in, we never use mock data even if isLoggedInAuth0ExperienceGlobal hasn't updated yet
  const isAuthenticated = auth0IsAuthenticated ? true : (isLoggedInAuth0ExperienceGlobal ? false : true);
  const userData = auth0IsAuthenticated ? user : (isLoggedInAuth0ExperienceGlobal ? null : NON_LOGGED_IN_CONFIG.NON_LOGGED_IN_USER);
  const authId = auth0IsAuthenticated ? user?.sub : (isLoggedInAuth0ExperienceGlobal ? null : NON_LOGGED_IN_CONFIG.NON_LOGGED_IN_AUTH_ID);

  // Log for debugging
  useEffect(() => {
    if (auth0IsAuthenticated) {
      //console.log(`[AUTH0 MODE] Using real Auth0 data. authId: ${user?.sub}`);
    } else if (!isLoggedInAuth0ExperienceGlobal) {
      //console.log(`[NON-LOGGED MODE] Using IP-based authId: ${authId}`);
    }
  }, [auth0IsAuthenticated, isLoggedInAuth0ExperienceGlobal, authId, user?.sub]);

  // //console.log("auth user data", userData);

  const userIdToken = userData?.sub;

  // Function to get access token from Auth0
  const getAccessTokenFromAuth0 = async (): Promise<string> => {
    // CRITICAL: If user is authenticated with Auth0, ALWAYS use real token (prevents race condition)
    // This ensures that if you're logged in, we never use mock token even if isLoggedInAuth0ExperienceGlobal hasn't updated yet
    if (auth0IsAuthenticated) {
      try {
        const accessTokenFromAuth0 = await getAccessTokenSilently();
        //console.log(`[AUTH0 MODE] Returning real access token for authenticated user`);
        return accessTokenFromAuth0;
      } catch (error) {
        setError("Failed to get access token. Please try again.");
        throw error;
      }
    }

    // If NOT authenticated AND in non-logged experience, use mock token
    if (!isLoggedInAuth0ExperienceGlobal) {
      //console.log(`[NON-LOGGED MODE] Returning mock access token in WidgetContext. authId: ${NON_LOGGED_IN_CONFIG.NON_LOGGED_IN_AUTH_ID}`);
      return NON_LOGGED_IN_CONFIG.NON_LOGGED_IN_ACCESS_TOKEN;
    }

    // If in Auth0 experience but NOT authenticated (waiting for auth), try to get real token
    try {
      const accessTokenFromAuth0 = await getAccessTokenSilently();
      return accessTokenFromAuth0;
    } catch (error) {
      setError("Failed to get access token. Please try again.");
      throw error;
    }
  };

  // Record this open's device context once per session (upsert by key; other devices stay).
  useEffect(() => {
    if (!authId || authId === "non-logged-in-auth-id-rotogpt-2025") return;
    let cancelled = false;
    void (async () => {
      try {
        const payload = await buildClientContext();
        const sessionKey = `client-context:${authId}:${payload.key}`;
        // console.log("sessionKey is", sessionKey);
        if (sessionStorage.getItem(sessionKey) === "1") return;
        const token = await getAccessTokenFromAuth0();
        if (cancelled) return;
        await postClientContext(token, payload);
        sessionStorage.setItem(sessionKey, "1");
      } catch {
        /* non-fatal */
      }
    })();
    return () => {
      cancelled = true;
    };
    // getAccessTokenFromAuth0 is recreated each render; authId is the trigger.
  }, [authId]);

  // Backend stores POC token in Redis (9h); returns only { success }. Token never touches front.
  const fetchPocToken = async () => {
    try {
      setIsTokenLoading(true);
      const accessTokenFromAuth0 = await getAccessTokenFromAuth0();
      const data = await getPocToken(accessTokenFromAuth0);
      // New contract: backend returns { success: boolean, message? }; no token value
      if (data?.success) {
        setPocToken("ready");
        setClientIdToken(null);
      } else {
        setPocToken(null);
      }
    } catch (error) {
      setError("Request failed. Please try again.");
      setPocToken(null);
    } finally {
      setIsTokenLoading(false);
    }
  };

  useEffect(() => {
    if (isAuthenticated) {
      fetchPocToken();
    }
  }, [isAuthenticated]);

  // // useEffect to load season pass price from backend on app start
  // useEffect(() => {
  //   const loadSeasonPassPrice = async () => {
  //     try {
  //       const price = await getSeasonPassPrice();
  //       setSeasonPassPrice(price);
  //       //console.log("WIDGETCONTEXT: Loaded seasonPassPrice from backend:", price);
  //     } catch (error) {
  //       console.error("Error loading season pass price:", error);
  //       // Keep default value "1" if fetch fails
  //     }
  //   };

  //   // Load season pass price immediately when component mounts (no auth required)
  //   loadSeasonPassPrice();
  // }, []);

  // Modify the resetAppState function to keep more preferences
  const resetAppState = useCallback(() => {
    setWidgetToggle(false);
    setIsDrawerOpen(false);
    setselectedClientId("DTC");
    setMessage("Welcome to RotoGPT. Let's get started.");
    // No reset the selectedPartner and selectedTeamInfo
    // No reset the leaguePlatforms, teamsDataCache and userDataCache
  }, []);

  // useEffect to update selectedTeamInfo, selectedPartner, and leagueIdPlatform when leaguePlatforms or selectedTeams change
  // Synced platforms: do NOT auto-restore from selectedTeams (manual TeamsDropdown pick). Prefs still store selectedTeams.
  // Un-Synced: keep restore so local league lands after prefs load (boot effect in LeagueSelector also covers cold start).
  // To RE-ENABLE synced silent restore: remove the !isUnsyncedPlatform early return below.
  useEffect(() => {
    const selectedPlatform = leaguePlatforms.find((p) => p.isSelected);
    if (!selectedPlatform || !isUnsyncedPlatform(selectedPlatform.id)) return;

    if (selectedTeams[selectedPlatform.id] && teamsDataCache[selectedPlatform.id]) {
      const teamInfo = selectedTeams[selectedPlatform.id];
      const platformTeamsData = teamsDataCache[selectedPlatform.id];

      if (platformTeamsData && platformTeamsData.leagues) {
        const teamExists = validateTeamData(teamInfo, platformTeamsData);

        if (teamExists) {
          setSelectedTeamInfo(teamInfo);
          setSelectedPartner(teamInfo.teamName);
          setLeagueIdPlatform(teamInfo.leagueId);
          setMessage("Use the buttons below for quick detailed insights into your team");
        }
      }
    }
  }, [leaguePlatforms, selectedTeams, teamsDataCache, preferencesLoaded]);

  // UseEffect to load user preferences
  useEffect(() => {
    const loadUserPreferences = async () => {
      // CRITICAL: Execute for BOTH logged (isAuthenticated) AND non-logged (isLoggedInAuth0ExperienceGlobal === false)
      // In NON-LOGGED, we need to load preferences using mock token to populate teamsDataCache
      const shouldLoad = (isAuthenticated || !isLoggedInAuth0ExperienceGlobal) && !preferencesLoaded && pocToken;

      if (shouldLoad) {
        try {
          setIsLoadingPreferences(true);
          // const preferences = await getUserPreferences(accessAuthToken);
          const accessAuthToken = await getAccessTokenFromAuth0();
          const [platformsFromServer, buttonsSectionsFromServer] = await Promise.all([
            getAllowedPlatforms(accessAuthToken, pocToken),
            getAllowedButtonsSections(accessAuthToken, pocToken),
          ]);
          //console.log("WIDGETCONTEXT loadUserPreferences: Allowed platforms from server:", platformsFromServer);
          //console.log("WIDGETCONTEXT loadUserPreferences: Allowed buttons/sections from server:", buttonsSectionsFromServer);
          setAllowedPlatforms(platformsFromServer);
          setAllowedButtonsSections(buttonsSectionsFromServer);

          // Auth0 only: one-time claim of non-logged prefs (device cookie match). Never block load on failure.
          if (auth0IsAuthenticated && isLoggedInAuth0ExperienceGlobal) {
            try {
              await claimNonLoggedPreferences(accessAuthToken);
            } catch (claimError) {
              console.error(
                "[claimNonLoggedPreferences] Claim failed (continuing with Auth0 prefs load):",
                claimError,
              );
            }
          }

          const preferences = await getUserPreferences(accessAuthToken);

          // //console.log("🔍 WIDGETCONTEXT: getUserPreferences preferences:", JSON.stringify(preferences.calculatorSettingsMap, null, 2));

          if (preferences) {
            // First restore the platforms
            const lastSelectedPlatform = preferences.loggedPlatforms?.find((p) => p.isSelected);

            // Un-Synced only: one-time migrate legacy fixed id "unsynced-default" → unique id (autosave persists)
            const restoredUnsyncedRaw = preferences.teamsData?.[UNSYNCED_PLATFORM_ID];
            const { teamsData: migratedUnsynced, newLeagueId: migratedUnsyncedLeagueId } =
              migrateLegacyUnsyncedDefaultLeagueId(restoredUnsyncedRaw);

            // First restore the selectedTeams (do not inject Un-Synced — same per-platform rule as Sleeper/MFL)
            if (preferences.selectedTeams) {
              const unsyncedSelected = preferences.selectedTeams[UNSYNCED_PLATFORM_ID];
              const nextSelectedTeams =
                migratedUnsyncedLeagueId && unsyncedSelected?.leagueId === UNSYNCED_DEFAULT_LEAGUE_ID
                  ? {
                    ...preferences.selectedTeams,
                    [UNSYNCED_PLATFORM_ID]: {
                      ...unsyncedSelected,
                      leagueId: migratedUnsyncedLeagueId,
                    },
                  }
                  : preferences.selectedTeams;
              setSelectedTeams(nextSelectedTeams);
            }

            // Update the platforms keeping the login and selection state
            setLeaguePlatforms((prev) => {
              const updatedPlatforms = prev.map((platform) => {
                // Un-Synced is always logged in (virtual platform)
                if (isUnsyncedPlatform(platform.id)) {
                  const savedPlatform = preferences.loggedPlatforms?.find((p) => p.id === platform.id);
                  return {
                    ...platform,
                    isLoggedIn: true,
                    isSelected: savedPlatform?.isSelected ?? false,
                  };
                }
                const savedPlatform = preferences.loggedPlatforms?.find((p) => p.id === platform.id);
                if (savedPlatform) {
                  return {
                    ...platform,
                    isLoggedIn: savedPlatform.isLoggedIn,
                    isSelected: savedPlatform.isSelected,
                  };
                }
                return platform;
              });

              // If there is no selected platform but there are logged platforms
              // Prefer a real synced platform over Un-Synced when auto-picking
              if (!updatedPlatforms.some((p) => p.isSelected) && updatedPlatforms.some((p) => p.isLoggedIn)) {
                const firstLoggedPlatform =
                  updatedPlatforms.find((p) => p.isLoggedIn && !isUnsyncedPlatform(p.id)) ||
                  updatedPlatforms.find((p) => p.isLoggedIn);
                if (firstLoggedPlatform) {
                  firstLoggedPlatform.isSelected = true;
                }
              }

              return updatedPlatforms;
            });

            // Restore the caches (reuse in-memory Un-Synced seed if Mongo has none — do not regenerate league_id)
            if (preferences.teamsData) {
              setTeamsDataCache((prev) => ({
                ...preferences.teamsData,
                [UNSYNCED_PLATFORM_ID]:
                  migratedUnsynced?.leagues?.length > 0 ? migratedUnsynced : prev[UNSYNCED_PLATFORM_ID],
              }));
            }
            if (preferences.userDataPlatform) {
              setUserDataCache({
                ...preferences.userDataPlatform,
                // Always keep synthetic null credentials for Un-Synced
                [UNSYNCED_PLATFORM_ID]: getUnsyncedUserData(),
              });
            } else {
              setUserDataCache((prev) => ({
                ...prev,
                [UNSYNCED_PLATFORM_ID]: getUnsyncedUserData(),
              }));
            }
            if (preferences.sectionData) {
              setSectionData(preferences.sectionData);
            }
            if (preferences.lastUpdatedTimestamps) {
              setLastUpdatedTimestamps(preferences.lastUpdatedTimestamps);
            }
            if (preferences.calculatorSettingsMap) {
              setCalculatorSettingsMap(preferences.calculatorSettingsMap);
            }
            if (preferences.keeperDrawerSeenMap) {
              setKeeperDrawerSeenMap(preferences.keeperDrawerSeenMap);
            }
            if (typeof preferences.footerSignUpDismissedAt === "string" && preferences.footerSignUpDismissedAt.length > 0) {
              setFooterSignUpDismissedAt(preferences.footerSignUpDismissedAt);
            }
            if (preferences.aiSettings && typeof preferences.aiSettings === "object") {
              const nextAiSettings = {
                audio: preferences.aiSettings.audio ?? true,
                quan: preferences.aiSettings.quan ?? true,
                mute: preferences.aiSettings.mute ?? false,
                // Run All Agents hidden in UI — never restore persisted true (LeagueSelector AutoProcessAISwitch commented)
                autoProcessAI: false,
                //if you want to make autoProccessAi working again, uncomment the line below and also show in LeagueSelector the box with AutoProcessAISwitch
                // autoProcessAI: preferences.aiSettings.autoProcessAI ?? false,
                ...(preferences.aiSettings.quanDefault !== undefined &&
                  preferences.aiSettings.quanDefault !== null
                  ? { quanDefault: preferences.aiSettings.quanDefault }
                  : {}),
              } as Record<string, boolean>;
              setAiSettings(nextAiSettings);
            }

            // [AUTO-SELECTION DISABLED] Do not restore the last selected team automatically
            /*
            // Restore the selected team
            if (lastSelectedPlatform) {
              const platformId = lastSelectedPlatform.id;
              const teamInfo = preferences.selectedTeams?.[platformId];
              const platformTeamsData = preferences.teamsData?.[platformId];

              if (teamInfo && platformTeamsData) {
                // Use validateTeamData to verify that the team exists
                const teamExists = validateTeamData(teamInfo, platformTeamsData);

                if (teamExists) {
                  setSelectedTeamInfo(teamInfo);
                  setSelectedPartner(teamInfo.teamName);
                  setLeagueIdPlatform(teamInfo.leagueId);
                  setMessage("Use the buttons below for quick detailed insights into your team");

                  if (platformId === "Yahoo" && yahooToken) {
                    setYahooLeagueId(teamInfo.leagueId);
                  }
                }
              }
            }
            */

            // [AUTO-SELECTION DISABLED] Do not select the first Yahoo team automatically
            /*
            // If there is no selected team for Yahoo, select the first team
            if (teamsDataCache["Yahoo"]?.leagues?.length > 0 && !preferences?.selectedTeams?.["Yahoo"]) {
              // Get the first team
              const firstTeam = teamsDataCache["Yahoo"].leagues[0];
              // Create a teamInfo object with the platformId, teamName and leagueId
              const teamInfo = {
                platformId: "Yahoo",
                teamName: firstTeam.name,
                leagueId: firstTeam.league_id,
              };

              // Update selectedTeams with the first team
              setSelectedTeams((prev) => ({
                ...prev,
                Yahoo: teamInfo,
              }));

              // Update related states
              setSelectedTeamInfo(teamInfo);
              setSelectedPartner(firstTeam.name);
              setLeagueIdPlatform(firstTeam.league_id);
              setMessage("Use the buttons below for quick detailed insights into your team");
            }
            */
          }
          setPreferencesLoaded(true);
        } catch (error) {
          console.error("Error loading preferences:", error);
        } finally {
          setIsLoadingPreferences(false);
        }
      }
    };

    loadUserPreferences();
  }, [isAuthenticated, isLoggedInAuth0ExperienceGlobal, preferencesLoaded, pocToken, auth0IsAuthenticated]);

  // After non-logged → Auth0 login (SPA navigate /home), force prefs reload so claim + Auth0 GET run.
  // Hard reload (Capacitor) already starts with preferencesLoaded=false; this covers SPA without remount.
  useEffect(() => {
    const isAuth0Home =
      auth0IsAuthenticated && isLoggedInAuth0ExperienceGlobal;
    if (isAuth0Home && !wasAuth0LoggedExperienceRef.current) {
      setPreferencesLoaded(false);
    }
    wasAuth0LoggedExperienceRef.current = isAuth0Home;
  }, [auth0IsAuthenticated, isLoggedInAuth0ExperienceGlobal]);

  // Modify the useEffect for saving preferences
  useEffect(() => {
    let isMounted = true;
    const abortController = new AbortController();

    // Function to save preferences
    const savePreferences = async (isRetry: boolean) => {
      // if (isAuthenticated && accessAuthToken && preferencesLoaded) {
      if (isAuthenticated && preferencesLoaded) {
        try {
          // Check if there are changes in the preferences
          const hasChanges =
            // Check if there are changes in the league platforms
            !isEqual(leaguePlatforms, previousLeaguePlatforms.current) ||
            // Check if there are changes in the teams data
            !isEqual(teamsDataCache, previousTeamsCache.current) ||
            // Check if there are changes in the user data
            !isEqual(userDataCache, previousUserCache.current) ||
            // Check if there are changes in the selected teams
            !isEqual(selectedTeams, previousSelectedTeams.current) ||
            !isEqual(lastUpdatedTimestamps, previousTimestamps.current) ||
            !isEqual(calculatorSettingsMap, previousCalculatorSettingsMap.current) ||
            !isEqual(keeperDrawerSeenMap, previousKeeperDrawerSeenMap.current) ||
            !isEqual(aiSettings, previousAiSettings.current) ||
            footerSignUpDismissedAt !== previousFooterSignUpDismissedAt.current;

          // Check if there are changes in the preferences and if there is no priority operation
          if (hasChanges && !isPriorityOperation) {
            // Only execute if there is no priority operation
            const accessAuthToken = await getAccessTokenFromAuth0();
            // //console.log("🔍 WIDGETCONTEXT: Sending calculatorSettingsMap:", JSON.stringify(calculatorSettingsMap, null, 2));
            await postUserPreferences(
              accessAuthToken,
              {
                loggedPlatforms: leaguePlatforms,
                teamsData: teamsDataCache,
                userDataPlatform: userDataCache,
                selectedTeams: selectedTeams,
                lastUpdatedTimestamps: lastUpdatedTimestamps,
                calculatorSettingsMap: calculatorSettingsMap,
                keeperDrawerSeenMap: keeperDrawerSeenMap,
                aiSettings,
                footerSignUpDismissedAt,
              }
              // abortController.signal
            );
            // //console.log("WIDGETCONTEXT savePreferences");

            // Update references if the component is mounted
            if (isMounted) {
              previousLeaguePlatforms.current = leaguePlatforms;
              previousTeamsCache.current = teamsDataCache;
              previousUserCache.current = userDataCache;
              previousSelectedTeams.current = selectedTeams;
              previousTimestamps.current = lastUpdatedTimestamps;
              previousCalculatorSettingsMap.current = calculatorSettingsMap;
              previousKeeperDrawerSeenMap.current = keeperDrawerSeenMap;
              previousAiSettings.current = aiSettings;
              previousFooterSignUpDismissedAt.current = footerSignUpDismissedAt;
            }
          }
        } catch (error) {
          // If the error is not an AbortError and the component is mounted, retry the operation
          if (error.name !== "AbortError" && isMounted && !isRetry && !isPriorityOperation) {
            setTimeout(() => savePreferences(true), 1000);
          }
        }
      }
    };

    // Increase debounce timeout to reduce unnecessary calls
    const debounceTimeout = setTimeout(() => savePreferences(false), 2000);

    // Cleanup function to reset the component state
    return () => {
      isMounted = false;
      abortController.abort();
      clearTimeout(debounceTimeout);
    };
  }, [leaguePlatforms, teamsDataCache, userDataCache, selectedTeams, isAuthenticated, preferencesLoaded, isPriorityOperation, lastUpdatedTimestamps, calculatorSettingsMap, keeperDrawerSeenMap, aiSettings, footerSignUpDismissedAt]);

  // Function to update platform data
  const updatePlatformData = (data: PlatformData) => {
    const { platformId, teamsData, userData } = data;

    // If it is Yahoo, we don't save userData
    if (platformId.toLowerCase() === "yahoo") {
      // Only update teamsData
      setTeamsDataCache((prev) => ({
        ...prev,
        [platformId]: teamsData,
      }));
    } else {
      // For other platforms, update both
      setTeamsDataCache((prev) => ({
        ...prev,
        [platformId]: teamsData,
      }));

      // update user data cache
      setUserDataCache((prev) => ({
        ...prev,
        [platformId]: userData,
      }));
    }
  };

  // function to update section data
  const updateSectionData = (section: keyof SectionData, data: any) => {
    setSectionData((prev) => ({
      ...prev,
      [section]: data,
    }));
  };

  // function to handle team selection and persistence
  const handleTeamSelection = async (teamName: string, leagueId: string) => {
    const selectedPlatform = leaguePlatforms.find((p) => p.isSelected);
    if (!selectedPlatform) return;

    // Update leagueIdPlatform
    setLeagueIdPlatform(leagueId);

    // update cache and local storage for yahoo
    if (selectedPlatform.id === "Yahoo") {
      localStorage.setItem("yahoo_league_id", leagueId);
    }

    // Reset sectionData when changing team
    setSectionData({
      commonLeagueData: null,
      // waiverSuggestions: null,
      waiver: null,
      news: null,
      start: null,
      rosters: null,
      rankings: null,
      allRankings: null,
      rundown: null,
      DraftAdvice: null,
      superFunction: null,
    });

    const teamInfo = {
      platformId: selectedPlatform.id,
      teamName,
      leagueId,
    };

    // Update selected teams map
    setSelectedTeams((prev) => ({
      ...prev,
      [selectedPlatform.id]: teamInfo,
    }));

    setSelectedTeamInfo(teamInfo);
    setSelectedPartner(teamName);
  };

  // Function to update Yahoo token
  const updateYahooToken = (newToken: string | null) => {
    if (newToken) {
      localStorage.setItem("yahoo_token", newToken);
    } else {
      localStorage.removeItem("yahoo_token");
    }
    setYahooToken(newToken);

    // Actualizar userDataCache
    setUserDataCache((prev) => ({
      ...prev,
      Yahoo: {
        ...prev.Yahoo,
        token: newToken,
      },
    }));
  };

  // Function to update Yahoo leagueId
  const updateYahooLeagueId = (newLeagueId: string | null) => {
    if (newLeagueId) {
      localStorage.setItem("yahoo_league_id", newLeagueId);
    } else {
      localStorage.removeItem("yahoo_league_id");
    }
    setYahooLeagueId(newLeagueId);
  };

  const previousLeaguePlatforms = useRef(leaguePlatforms);
  const previousTeamsCache = useRef(teamsDataCache);
  const previousUserCache = useRef(userDataCache);
  const previousSelectedTeams = useRef(selectedTeams);
  const previousTimestamps = useRef(lastUpdatedTimestamps);
  const previousCalculatorSettingsMap = useRef(calculatorSettingsMap);
  const previousKeeperDrawerSeenMap = useRef(keeperDrawerSeenMap);
  const previousAiSettings = useRef(aiSettings);
  const previousFooterSignUpDismissedAt = useRef(footerSignUpDismissedAt);

  // Initialize references when data is available
  useEffect(() => {
    if (preferencesLoaded) {
      previousLeaguePlatforms.current = leaguePlatforms;
      previousTeamsCache.current = teamsDataCache;
      previousUserCache.current = userDataCache;
      previousSelectedTeams.current = selectedTeams;
      previousTimestamps.current = lastUpdatedTimestamps;
      previousCalculatorSettingsMap.current = calculatorSettingsMap;
      previousKeeperDrawerSeenMap.current = keeperDrawerSeenMap;
      previousAiSettings.current = aiSettings;
      previousFooterSignUpDismissedAt.current = footerSignUpDismissedAt;
    }
  }, [preferencesLoaded, calculatorSettingsMap, keeperDrawerSeenMap, aiSettings, footerSignUpDismissedAt]);

  // Log notes for the currently selected team whenever calculatorSettingsMap or selectedTeamInfo changes
  useEffect(() => {
    if (selectedTeamInfo) {
      const currentTeamKey = `${selectedTeamInfo.platformId}-${selectedTeamInfo.leagueId}`;
      const currentTeamSettings = calculatorSettingsMap[currentTeamKey];
      const currentTeamNotes =
        currentTeamSettings && typeof currentTeamSettings === "object" && "notes" in currentTeamSettings ? currentTeamSettings.notes || "(empty)" : "(no settings for this team)";
      //console.log(`📌 WIDGETCONTEXT: Notes for current team (${currentTeamKey}):`, currentTeamNotes);
    }
  }, [calculatorSettingsMap, selectedTeamInfo]);

  // Function to cancel pending requests on purpose
  const cancelPendingRequests = () => {
    if (currentAbortController) {
      currentAbortController.abort();
      setCurrentAbortController(null);
    }
  };

  // Function to get a valid Yahoo token
  const getValidYahooToken = async (): Promise<string | null> => {
    try {
      const accessTokenFromAuth0 = await getAccessTokenFromAuth0();
      // Get a valid Yahoo token from the backend
      const validToken = await getValidYahooTokenfromBack({ accessTokenFromAuth0, authId });

      if (validToken) {
        // Update the token in the state
        updateYahooToken(validToken);
        return validToken;
      }

      return null;
    } catch (error) {
      console.error("Error getting valid Yahoo token:", error);
      return null;
    }
  };

  // //console.log("WIDGETCONTEXT yahooToken", yahooToken?.substring(0, 10) + "...");

  // 3. Create the guard here to be persistent throughout the session (not anymore in homepage.tsx)
  // const activeStreamRequests = useRef(new Set<string>());

  // Function to update button progress loader
  const updateButtonProgress = (key: string, progress: number) => {
    setButtonProgress((prev) => ({
      ...prev,
      [key]: {
        progress,
        timestamp: prev[key]?.timestamp || Date.now(),
      },
    }));
  };

  // Function to get button progress loader
  const getButtonProgress = (key: string): number => {
    const data = buttonProgress[key];
    if (!data) return 0;

    // Check if progress is older than 1 hour
    const oneHour = 60 * 60 * 1000;
    const isExpired = Date.now() - data.timestamp > oneHour;

    // Return the progress or 0 if it is expired
    return isExpired ? 0 : data.progress;
  };

  // Function to force immediate save of preferences to MongoDB (bypasses debounce)
  // Used when we need to persist changes immediately (e.g., after RESET CHANGES, or after user confirms AI settings)
  // Optional overrides allow saving a value before React state has updated (e.g. aiSettings from dialog confirm)
  const forceSavePreferences = async (overrides?: Partial<Pick<UserPreferencesData, "aiSettings" | "keeperDrawerSeenMap" | "footerSignUpDismissedAt">>): Promise<void> => {
    if (isAuthenticated && preferencesLoaded) {
      try {
        const accessAuthToken = await getAccessTokenFromAuth0();
        const aiSettingsToSave = overrides?.aiSettings ?? aiSettings;
        const keeperDrawerSeenMapToSave = overrides?.keeperDrawerSeenMap ?? keeperDrawerSeenMap;
        const footerSignUpDismissedAtToSave = overrides?.footerSignUpDismissedAt ?? footerSignUpDismissedAt;
        // //console.log("🔍 WIDGETCONTEXT: Force saving calculatorSettingsMap:", JSON.stringify(calculatorSettingsMap, null, 2));
        await postUserPreferences(accessAuthToken, {
          loggedPlatforms: leaguePlatforms,
          teamsData: teamsDataCache,
          userDataPlatform: userDataCache,
          selectedTeams: selectedTeams,
          lastUpdatedTimestamps: lastUpdatedTimestamps,
          calculatorSettingsMap: calculatorSettingsMap,
          keeperDrawerSeenMap: keeperDrawerSeenMapToSave,
          aiSettings: aiSettingsToSave,
          footerSignUpDismissedAt: footerSignUpDismissedAtToSave,
        });

        // Update references to prevent duplicate saves
        previousLeaguePlatforms.current = leaguePlatforms;
        previousTeamsCache.current = teamsDataCache;
        previousUserCache.current = userDataCache;
        previousSelectedTeams.current = selectedTeams;
        previousTimestamps.current = lastUpdatedTimestamps;
        previousCalculatorSettingsMap.current = calculatorSettingsMap;
        previousKeeperDrawerSeenMap.current = keeperDrawerSeenMapToSave;
        previousAiSettings.current = aiSettingsToSave;
        previousFooterSignUpDismissedAt.current = footerSignUpDismissedAtToSave;

        //console.log("✅ WIDGETCONTEXT: Force save completed");
      } catch (error) {
        console.error("❌ WIDGETCONTEXT: Error forcing save:", error);
        throw error;
      }
    }
  };

  return (
    <WidgetContext.Provider
      value={{
        widgetToggle,
        toggleWidget,
        closeWidget,
        selectedClientId,
        handleUserSelection,
        selectedPartner,
        setSelectedPartner,
        handlePartnerSelect,
        isDrawerOpen,
        openDrawer,
        closeDrawer,
        setIsDrawerOpen,
        partners,
        pocToken,
        userIdToken,
        clientIdToken,
        leaguePlatforms,
        setLeaguePlatforms,
        resetAppState,
        isTokenLoading,
        // accessAuthToken,
        message,
        setMessage,
        teamsDataCache,
        setTeamsDataCache,

        userDataCache,
        setUserDataCache,
        isLoadingPreferences,
        updatePlatformData,
        selectedTeamInfo,
        setSelectedTeamInfo,
        handleTeamSelection,
        sectionData,
        setSectionData,
        updateSectionData,
        selectedTeams,
        setSelectedTeams,
        aiSettings,
        setAiSettings,
        setYahooToken: updateYahooToken,
        updateYahooToken,
        yahooToken,
        setYahooLeagueId: updateYahooLeagueId,
        yahooLeagueId,
        isYahooLoading,
        setIsYahooLoading,
        leagueIdPlatform,
        setLeagueIdPlatform,
        dataLoadedFromTeamsPage,
        setDataLoadedFromTeamsPage,
        cancelPendingRequests,
        setCurrentAbortController,

        getValidYahooToken,
        commonLeagueLeagueType,
        setCommonLeagueLeagueType,
        isTransitioning,
        setIsTransitioning,
        // activeStreamRequests,
        buttonProgress,
        updateButtonProgress,
        getButtonProgress,
        allowedPlatforms,
        setAllowedPlatforms,
        allowedButtonsSections,
        setAllowedButtonsSections,
        lastUpdatedTimestamps,
        setLastUpdatedTimestamps,
        calculatorSettingsMap,
        setCalculatorSettingsMap,
        keeperDrawerSeenMap,
        setKeeperDrawerSeenMap,
        footerSignUpDismissedAt,
        setFooterSignUpDismissedAt,
        forceSavePreferences,
        credits,
        setCredits,
        freeCredits,
        setFreeCredits,
        nextFreeCreditsResetTime,
        setNextFreeCreditsResetTime,
        isIdpLeagueBlocked,
        setIsIdpLeagueBlocked,
        seasonPassPrice,
        setSeasonPassPrice,
        isLoggedInAuth0ExperienceGlobal,
        setIsLoggedInAuth0ExperienceGlobal,
        NON_LOGGED_IN_CONFIG,
      }}
    >
      {children}
    </WidgetContext.Provider>
  );
};
